import { useEffect } from 'react'
import { NATIVE_CURRENCY, WRAPPED_ETHER } from '../constants'
import { Currency } from '../model'
import { useSettings, useStickyCurrencies } from '../providers'

function getPreferredCurrency(currency: Currency, useWeth: boolean) {
  if (useWeth) {
    return currency === NATIVE_CURRENCY[currency.chainId] ? WRAPPED_ETHER[currency.chainId] : currency
  } else {
    return currency === WRAPPED_ETHER[currency.chainId] ? NATIVE_CURRENCY[currency.chainId] : currency
  }
}

export function useStickyPreferredCurrency() {
  const { settings } = useSettings()

  const { stickyCurrencies, setStickyCurrencies } = useStickyCurrencies()

  const first = getPreferredCurrency(stickyCurrencies.first, settings.useWeth)
  const second = getPreferredCurrency(stickyCurrencies.second, settings.useWeth)

  function setCurrencies(first: Currency, second: Currency) {
    if (first.symbol === second.symbol) {
      throw new Error('Cannot set currencies to same symbol')
    }
    setStickyCurrencies({
      first: getPreferredCurrency(first, settings.useWeth),
      second: getPreferredCurrency(second, settings.useWeth),
    })
  }

  function swap() {
    setStickyCurrencies({
      first: getPreferredCurrency(second, settings.useWeth),
      second: getPreferredCurrency(first, settings.useWeth),
    })
  }

  useEffect(() => {
    setCurrencies(first, second)
  }, [settings])

  return [first, second, setCurrencies, swap] as const
}
